import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Image,
  Button,
  Accordion,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { Rating } from "react-simple-star-rating";
import { InfoIcon, DeliveryVanIcon } from "../../assets/svg/svg-icons";
import { CartIcon, DotIcon } from "../../assets/svg/svg-icons";
import fulfill from "../../assets/images/fulfill.png";
import RefferSection from "../common/RefferSection";

import plastic1 from "../../assets/images/plastic-1.png";
import { Link, useNavigate } from "react-router-dom";
import BrandCard from "../Brands/BrandCard";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./product.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getApi,
  getProductDetailsAPI,
  postCart,
  postEnquiry,
} from "../../actions/structure.action";
import { useParams } from "react-router-dom";
import convertToLiters from "../../utils/convertToLiters";
import isEmpty from "../../utils/is-Empty";
import Spinner from "../common/Spinner";
import CustomButton from "../common/CustomButton";
import CustomSelectDropdown from "../common/CustomSelectDropdown";
import { deliverytypesString } from "../../helpers/table-structures";
import { appConstants, stringConstants } from "../../helpers";
import FilterObjectsByKeyValue from "../../utils/FilterObjectsByKeyValue";
import { use } from "react";
import getBuyerDefaultAddress from "../../utils/getBuyerDefaultAddress";

function Product() {
  const navigate = useNavigate();
  // const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  // const params = useParams();

  const params = new URLSearchParams(window.location.search);
  const refFilter = useRef([]);
  const refMobileFilter = useRef([]);
  const { currentProduct, auth, requestCall, appconfig, addresses } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    if (auth?.user?.role?.role_name === stringConstants.ROLL_SELLER) {
      navigate("/seller/profile-panel");
    }
  }, [auth, navigate]);

  const [overlayPosition, setOverlayPosition] = useState("right");
  const [selectedSize, setSelectedSize] = useState("1L");
  const [selectedMOQ, setSelectedMOQ] = useState(200);
  const [selectedPaymentOption, setSelectedMOQPaymentOption] = useState({});
  const [selectedDeliveryOption, setSelectedDeliveryOption] = useState({});
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [handlingCharges, setHandlingCharges] = useState(0);
  const [isSellerAdvanced, setIsSellerAdvanced] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [buyerDefaultAddress, setBuyerDefaultAddress] = useState(null);

  useEffect(() => {
    if (!isEmpty(addresses) && addresses?.data?.length > 0) {
      console.log("My Addresses: ", addresses);
      const mDefaultAddress = getBuyerDefaultAddress(addresses?.data);
      console.log("My DEFAULT Address: ", mDefaultAddress);
      setBuyerDefaultAddress(mDefaultAddress);
    }
  }, [addresses]);

  const enquireText = (
    <p>
      {
        "The seller details will be available after you submit the Enquiry and the seller accepts it. To submit an enquiry, please click on the Enquire button above."
      }
    </p>
  );

  const noLoginText = (
    <p>
      {"The details of this section will be available after you login. Please "}
      <span className="text-primary text-link" onClick={() => openLoginModal()}>
        Login
      </span>
      {" to view the details."}
    </p>
  );

  useEffect(() => {
    setErrorMsg("");
    if (localStorage.getItem("localSelectedDistrict")) {
      getProductDetailsAPI(dispatch, id, localStorage.getItem("localSelectedDistrict"));
    } else {
      getApi("getProductDetails", dispatch, "/" + id);
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (auth.loggedIn && !isEmpty(auth?.user)) {
      getApi("getAddressess", dispatch);
    }
  }, [dispatch, auth]);

  const handleScrollView = () => {
    if (window.scrollY !== 0) {
      if (window.innerWidth < 768) {
        refMobileFilter.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      } else {
        refFilter.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  };

  const addToCart = (data, moq) => {
    let postData = {};
    postData["product_variant_id"] = data.id;
    postData["buyer_id"] = auth.user.id;
    postData["moq"] = moq.quantity;
    postData["payment_types"] = selectedPaymentOption;
    postCart(postData, dispatch).then((res) => {
      console.log("Product > Post Cart Response: ", res);
      if (res.success) {
        setTimeout(() => {
          navigate("/cart");
        }, 500);
      }
    });
  };

  const addToCartCurrentProduct = (data) => {
    let postData = {};
    postData["product_variant_id"] = data.id;
    postData["buyer_id"] = auth.user.id;
    postData["moq"] = selectedMOQ;
    postData["payment_types_id"] = selectedPaymentOption.id;
    postData["delivery_types_id"] = selectedDeliveryOption.id;
    postCart(postData, dispatch).then((res) => {
      console.log("Product > addToCartCurrentProduct > Post Cart Response: ", res);
      if (res.success) {
        setTimeout(() => {
          navigate("/cart");
        }, 500);
      }
    });
  };

  const submitEnquiry = async (data) => {
    setErrorMsg("");
    let postData = {};
    postData["product_variant_id"] = data.productDetails.id;
    postData["buyer_id"] = auth.user.id;

    let selectedMOQData = data.moqArr.filter((moq) => selectedMOQ === moq.quantity)[0];
    postData["moq_id"] = selectedMOQData.id;
    postData["moq"] = selectedMOQ;

    const postResponse = await postEnquiry(postData, dispatch);
    if (postResponse) {
      if (postResponse.success) {
        navigate(`/enquiry/${postResponse?.data?.enquiryId}`);
      } else {
        setErrorMsg(postResponse.message);
      }
    }
  };

  useEffect(() => {
    setErrorMsg("");
    if (!isEmpty(currentProduct?.data)) {
      handleScrollView();
      setSelectedSize(currentProduct?.data?.productDetails?.variant);
      setHandlingCharges(parseFloat(currentProduct?.data?.productDetails?.handling_charges));

      setSelectedMOQPaymentOption(
        FilterObjectsByKeyValue(
          currentProduct?.data?.productDetails?.payment_types,
          "name",
          "Pay Now",
        )[0],
      );
      if (
        !isEmpty(
          FilterObjectsByKeyValue(
            currentProduct?.data?.productDetails?.delivery_types,
            "name",
            "Bharee",
          ),
        )
      ) {
        setSelectedDeliveryOption(
          FilterObjectsByKeyValue(
            currentProduct?.data?.productDetails?.delivery_types,
            "name",
            "Bharee",
          )[0],
        );
      } else {
        setSelectedDeliveryOption(
          FilterObjectsByKeyValue(
            currentProduct?.data?.productDetails?.delivery_types,
            "name",
            "Standard",
          )[0],
        );
      }
      if (isEmpty(params.get("moq"))) {
        setSelectedMOQ(currentProduct?.data?.productDetails?.moq_id[0]?.quantity);
      } else {
        setSelectedMOQ(parseInt(params.get("moq")));
      }
    }
  }, [currentProduct.data]);

  // useEffect on currentProduct.data and selectedMOQ
  useEffect(() => {
    if (!isEmpty(currentProduct) && !isEmpty(selectedMOQ)) {
      console.log(">>>> CURRENT PRODUCT: ", currentProduct);
      if (currentProduct?.data?.productDetails?.app_features === "leads") {
        setIsSellerAdvanced(false);
      } else {
        if (selectedMOQ <= currentProduct?.data?.productDetails?.app_features_details?.moq) {
          setIsSellerAdvanced(true);
        } else {
          setIsSellerAdvanced(false);
        }
      }
    }
  }, [currentProduct, selectedMOQ]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setOverlayPosition("bottom");
    }
  }, []);

  useEffect(() => {
    if (selectedDeliveryOption?.name === "Standard") {
      setDeliveryCharges(parseFloat(currentProduct?.data?.productDetails?.standardDeliveryCharge));
    } else {
      setDeliveryCharges(parseFloat(currentProduct?.data?.productDetails?.bhareeDeliveryCharge));
    }
  }, [selectedDeliveryOption]);

  const handleClick = (e, value) => {
    navigate(`/product/${value.id}`);
  };

  const openLoginModal = () => {
    const targetButton = document.getElementById("loginModal");
    if (targetButton) {
      targetButton.click();
    }
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 2.2,
    },
  };

  const popover = (
    <Popover id="popover-basic">
      {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
      <Popover.Body>
        {/* All discounts, promotional schemes & Bharee delivery option available only on advance
        payment.
        <br /> */}
        POD available in selected cities with Selected Sellers.
      </Popover.Body>
    </Popover>
  );

  const ProductBanner = (
    <>
      <div ref={refFilter} className="product-banner-main-div text-uppercase">
        <p>
          {" "}
          <Link to={`/`}>{"Home "}</Link>
          {<DotIcon />} <Link to={`/brands`}>{" Brand"}</Link>
        </p>
        <h2>{currentProduct?.data?.productDetails?.brand_name}</h2>
      </div>
      <div
        ref={refMobileFilter}
        className="mobile "
        style={{ visibility: "hidden", position: "absolute" }}
      >
        xyz
      </div>
    </>
  );

  const blandsSections = () => {
    let properties = {
      useBrowserFullscreen: false,
      showPlayButton: false,
      showBullets: false,
      showNav: false,
      showFullscreenButton: false,
      autoPlay: currentProduct?.data?.productDetails?.productImages?.length > 3 ? true : false,
      originalClass: "galaryBigImage",
      items:
        currentProduct?.data?.productDetails?.productImages?.length > 0
          ? currentProduct?.data?.productDetails?.productImages.map((item) => {
              let tempItem = {};
              tempItem["originalClass"] = "galaryBigImage";
              tempItem["originalHeight"] = "auto";
              tempItem["originalWidth"] = "auto";
              tempItem["original"] = item.url;
              tempItem["thumbnail"] = item.url;
              return tempItem;
            })
          : [
              {
                original: plastic1,
                originalClass: "galaryBigImage",
                originalHeight: "auto",
                originalWidth: "auto",
                thumbnail: plastic1,
              },
            ],
    };

    return (
      <div className="container product-div">
        <Row className="pt-5">
          <Col xs={12} sm={12} md={9} lg={9}>
            <Row className="m-0">
              <Col xs={12} sm={12} md={5} lg={5} className="product-details-section">
                <div className="desktop">
                  <ImageGallery {...properties} />
                </div>
                <Container className="p-0 mobile">
                  <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    // ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    // autoPlay={this.props.deviceType !== "mobile" ? true : false}
                    autoPlay={false}
                    autoPlaySpeed={2000}
                    keyBoardControl={true}
                    customTransition="transform 1000ms ease-in-out"
                    transitionDuration={500}
                    // containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    // deviceType={this.props.deviceType}
                    dotListClass="custom-dot-list-style"
                    // itemClass="carousel-item-padding-40-px"
                  >
                    {currentProduct?.data?.productDetails?.productImages?.length > 0 &&
                      currentProduct?.data?.productDetails?.productImages?.map((image, index) => {
                        return (
                          <div key={index} className="product-mobile-carousal-item">
                            <Image
                              src={image?.url}
                              style={{ maxWidth: "100%", height: "auto" }}
                            ></Image>
                          </div>
                        );
                      })}
                  </Carousel>
                </Container>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} className="poduct-custom-section">
                <div className="product-variant-div">
                  <div className="small-image-heading">
                    <p className="text-uppercase  m-0">
                      {currentProduct?.data?.productDetails?.brand_name}
                    </p>
                  </div>
                  <div className="small-image-heading">
                    <h4 style={{ textTransform: "uppercase" }}>
                      {currentProduct?.data?.productDetails?.brand_name}&nbsp;
                      {currentProduct?.data?.productDetails?.product_category}
                    </h4>
                    {deliverytypesString(currentProduct?.data?.productDetails?.delivery_types)
                      .toLowerCase()
                      .includes(appConstants.BHAREE.toLowerCase()) && (
                      <Image src={fulfill} alt="fulfill" />
                    )}
                    {/* <Image src={fulfill} alt="fulfill" /> */}
                  </div>
                  <div className="product-rating">
                    <Rating className="rating-star-container" size="20" initialValue={4} readonly />
                    <p>{"24 ratings"}</p>
                  </div>
                  <div className="variants-div  ">
                    <Row className="variant m-0">
                      <Col xs={12} sm={12} md={2} lg={2} className="p-0">
                        <p className="text-uppercase " style={{ marginRight: "10%" }}>
                          {"size:"}
                        </p>
                      </Col>
                      <Col xs={12} sm={12} md={10} lg={10} className="p-0">
                        {currentProduct?.data?.sizeArr?.map((product, i) => {
                          return (
                            <Link to={`/product/${product.id}`} key={i}>
                              <Button
                                type="button"
                                className={`product-quntity ${
                                  selectedSize === product?.variant && "active"
                                }`}
                              >
                                {" "}
                                {convertToLiters(product?.variant)}
                              </Button>
                            </Link>
                          );
                        })}
                      </Col>
                    </Row>
                    <Row className="variant m-0">
                      <Col xs={12} sm={12} md={2} lg={2} className="p-0">
                        <p className="text-uppercase">
                          {"moq(case):"} <br />
                          <span className="extra-small-text ">
                            {"Minimum Order"}
                            {" Quantity"}
                          </span>
                        </p>
                      </Col>
                      <Col xs={12} sm={12} md={10} lg={10} className="p-0">
                        {currentProduct?.data?.moqArr?.map((moq, i) => {
                          return (
                            <Button
                              type="button"
                              className={`product-moq ${selectedMOQ === moq.quantity && "active"}`}
                              onClick={() => setSelectedMOQ(moq.quantity)}
                              key={i}
                            >
                              {moq.displayName}
                            </Button>
                          );
                        })}
                      </Col>
                    </Row>
                  </div>
                  {auth.loggedIn && currentProduct?.data?.productDetails?.offers?.length > 0 && (
                    <Row className="m-0">
                      <p className="m-0 p-0 "> {"Available offers"}</p>
                      <ul className="px-3">
                        {currentProduct?.data?.productDetails?.offers.map((offer) => {
                          return (
                            <li>
                              {`₹ `}
                              <strong>{`${offer?.offerPrice}/case`}</strong>
                              {` for ${offer?.quantity} MOQ`}
                            </li>
                          );
                        })}
                      </ul>
                    </Row>
                  )}
                  <div className="w-100">
                    <div className="type-box">
                      <span>{convertToLiters(selectedSize)} &nbsp;</span>{" "}
                      <p className="border-p "></p>
                      {selectedMOQ && (
                        <span>
                          &nbsp;
                          {`  ${
                            currentProduct?.data?.moqArr?.find(
                              (moq) => moq.quantity === selectedMOQ,
                            )?.displayName
                          } Case`}
                        </span>
                      )}
                      {auth.loggedIn && (
                        <>
                          {(() => {
                            let offer = !isEmpty(currentProduct?.data)
                              ? FilterObjectsByKeyValue(
                                  currentProduct?.data?.productDetails?.offers,
                                  "quantity",
                                  selectedMOQ,
                                )
                              : [];
                            // [0].offerPrice}
                            if (
                              currentProduct?.data?.productDetails?.offers?.length > 0 &&
                              !isEmpty(offer)
                            ) {
                              return (
                                <>
                                  <h1>
                                    {"₹ "}
                                    {offer[0]?.offerPrice}
                                    {"/-"}
                                    <span>{" Per Case"}</span>
                                    &nbsp;
                                    <br className="mobile" />
                                    <span>
                                      &nbsp; &nbsp;
                                      <s>
                                        {`₹ ${currentProduct?.data?.productDetails?.price} / -`}
                                        <span>{" Per Case"}</span>
                                      </s>
                                    </span>
                                  </h1>
                                </>
                              );
                            } else {
                              return (
                                <h1>
                                  {"₹ "}
                                  {currentProduct?.data?.productDetails?.price}
                                  {"/-"}
                                  <span>{" Per Case"}</span>
                                </h1>
                              );
                            }
                          })()}
                        </>
                      )}
                    </div>
                  </div>
                  {!auth.loggedIn && <div className="additional-info mt-5">{noLoginText}</div>}
                  {
                    // If the seller type is isSellerAdvanced, show the payment option
                    auth.loggedIn && isSellerAdvanced && (
                      <Form.Group className="payment-option-check-box">
                        <Form.Label className="me-2">{"PAYMENT OPTION:"}</Form.Label>
                        {!isEmpty(currentProduct?.data.productDetails) &&
                          !isEmpty(currentProduct?.data.productDetails.payment_types) &&
                          currentProduct?.data?.productDetails?.payment_types?.length > 0 && (
                            <CustomSelectDropdown
                              style={{
                                multiselectContainer: {
                                  backgroundColor: "#ffffff",
                                },
                                chips: {
                                  margin: 0,
                                },
                                option: {
                                  background: "#fbb040",
                                  color: "#FFFFFF",
                                  borderBottom: "1px solid #FFFFFF",
                                },
                              }}
                              options={currentProduct?.data?.productDetails?.payment_types}
                              onSelect={(e) => setSelectedMOQPaymentOption(e[0])}
                              selectedValues={
                                !isEmpty(selectedPaymentOption) ? [selectedPaymentOption] : []
                              }
                              displayValue={"name"}
                              singleSelect
                            />
                          )}

                        <OverlayTrigger
                          trigger="click"
                          placement={overlayPosition}
                          overlay={popover}
                        >
                          <Button className="button-popover">
                            <InfoIcon />
                          </Button>
                        </OverlayTrigger>
                        {/* <InfoIcon /> */}
                      </Form.Group>
                    )
                  }
                  {auth.loggedIn && isSellerAdvanced && (
                    <div className="delivery mt-3 mb-3">
                      <Form.Label className="me-2 delivery-lable">{"DELIVERY OPTION:"}</Form.Label>
                      {currentProduct?.data?.productDetails?.delivery_types?.length > 0 &&
                        currentProduct?.data?.productDetails?.delivery_types.map((delivery) => {
                          return (
                            <div
                              onClick={() => setSelectedDeliveryOption(delivery)}
                              className={`delivery-option ${
                                delivery === selectedDeliveryOption ? "active" : ""
                              }`}
                            >
                              <div className="delivery-icon">
                                <DeliveryVanIcon />
                              </div>
                              <div className="px-2">
                                <h5 className="text-uppercase">{delivery?.name}</h5>
                                <p>{delivery?.subTitle}</p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                  {auth.loggedIn && (
                    <>
                      {isSellerAdvanced && (
                        <>
                          <h6>
                            {"Delivery Charges: ₹ "}{" "}
                            {(parseFloat(deliveryCharges) / 1.18).toFixed(0)}
                            {" /- "}
                            <span className="text-muted small">per case plus 18% GST</span>
                          </h6>
                          {handlingCharges > 0 && (
                            <h6>
                              {"Handling Charges: ₹ "}{" "}
                              {(parseFloat(handlingCharges) / 1.18).toFixed(0)}
                              {" /- "}
                              <span className="text-muted small">per case plus 18% GST</span>
                            </h6>
                          )}
                        </>
                      )}
                      <div className="total-amt">
                        <h6 className="text-uppercase">{"Total Amount:"}</h6>

                        {(() => {
                          let offer = !isEmpty(currentProduct?.data)
                            ? FilterObjectsByKeyValue(
                                currentProduct?.data?.productDetails?.offers,
                                "quantity",
                                selectedMOQ,
                              )
                            : [];
                          if (
                            currentProduct?.data?.productDetails?.offers?.length > 0 &&
                            !isEmpty(offer)
                          ) {
                            return (
                              <>
                                <h2>
                                  {`₹ ${
                                    isSellerAdvanced
                                      ? (
                                          selectedMOQ * parseFloat(offer[0]?.offerPrice) +
                                          selectedMOQ * deliveryCharges +
                                          selectedMOQ * handlingCharges
                                        ).toFixed(2)
                                      : (selectedMOQ * parseFloat(offer[0]?.offerPrice)).toFixed(2)
                                  } /-`}
                                  &nbsp; &nbsp;
                                  <span>
                                    <s>
                                      {`₹ ${
                                        isSellerAdvanced
                                          ? (
                                              selectedMOQ *
                                                currentProduct?.data?.productDetails?.price +
                                              selectedMOQ * deliveryCharges +
                                              selectedMOQ * handlingCharges
                                            ).toFixed(2)
                                          : (
                                              selectedMOQ *
                                              currentProduct?.data?.productDetails?.price
                                            ).toFixed(2)
                                      }`}
                                    </s>
                                    {"/-"}
                                  </span>
                                </h2>
                              </>
                            );
                          } else {
                            return (
                              <>
                                <h2>
                                  {`₹ ${
                                    isSellerAdvanced
                                      ? (
                                          selectedMOQ *
                                            currentProduct?.data?.productDetails?.price +
                                          selectedMOQ * deliveryCharges +
                                          selectedMOQ * handlingCharges
                                        ).toFixed(2)
                                      : (
                                          selectedMOQ * currentProduct?.data?.productDetails?.price
                                        ).toFixed(2)
                                  }/-`}
                                </h2>
                              </>
                            );
                          }
                        })()}
                      </div>
                      {auth?.user &&
                        currentProduct?.data &&
                        buyerDefaultAddress &&
                        buyerDefaultAddress?.city !== currentProduct?.data?.sellerAddress?.city && (
                          <p className="error-msg">
                            This seller is not available in your city ({buyerDefaultAddress?.city}).
                          </p>
                        )}
                      {
                        // If the seller type is isSellerAdvanced, show the add to cart and order now button
                        isSellerAdvanced &&
                          buyerDefaultAddress?.city ===
                            currentProduct?.data?.sellerAddress?.city && (
                            <div className="cart-order-div">
                              <CustomButton
                                className="text-uppercase cart-btn "
                                loading={requestCall?.loading}
                                style={{
      backgroundColor: "orange",
      color: "white",
   
    }}
                                onClick={() => {
                                  addToCartCurrentProduct(currentProduct?.data?.productDetails);
                                }}
                              >
                                {"ADD TO CART"}
                              </CustomButton>
                            </div>
                          )
                      }
                      {
                        // If the seller type is SELLER_BASIC, show the enquire button
                        !isSellerAdvanced &&
                          buyerDefaultAddress?.city ===
                            currentProduct?.data?.sellerAddress?.city && (
                            <>
                              <div className="cart-order-div">
                                <CustomButton
                                  className="text-uppercase order-btn"
                                  onClick={() => submitEnquiry(currentProduct?.data)}
                                >
                                  {"SUBMIT ENQUIRY"}
                                </CustomButton>
                              </div>
                              {errorMsg && <p className="error-msg">{errorMsg}</p>}
                            </>
                          )
                      }
                    </>
                  )}
                </div>
              </Col>
              <Col xs={12} sm={12} md={5} lg={5} className="product-details-section">
                <div className="product-discription-div desktop">
                  <h4 className="text-uppercase">{"Product Description"}</h4>
                  <hr />
                  <p>{currentProduct?.data?.productDetails?.description}</p>
                </div>
                <Accordion defaultActiveKey={null} className="product-discription-div mobile">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <h4 className="text-uppercase">{"Product Description"}</h4>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p>{currentProduct?.data?.productDetails?.description}</p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
              <Col xs={12} sm={12} md={7} lg={7} className="poduct-custom-section">
                <div className="product-variant-div desktop">
                  <div className="additional-info">
                    <h4 className="text-uppercase">{"additional information"}</h4>
                    <hr />
                    {
                      // Displaying additional information about the product only if the seller type is advanced
                      auth.loggedIn && (
                        <>
                          <p>
                            <span>{"Manufactured by: "}</span>
                            {currentProduct?.data?.productDetails?.manufactured_by}
                          </p>
                          <p>
                            <span>{"Marketed by: "}</span>
                            {currentProduct?.data?.productDetails?.marketed_by}
                          </p>
                          <p>
                            <span>{"Net Quantity: "}</span>
                            {convertToLiters(currentProduct?.data?.productDetails?.variant)}
                          </p>
                          <p>
                            <span>{"Customer care: "}</span>
                            {currentProduct?.data?.productDetails?.customer_care}
                          </p>
                          <p>
                            <span>{"Country of Origin: "}</span>
                            {currentProduct?.data?.productDetails?.country_of_origin}
                          </p>
                          <p>
                            <span>{"Shelf life: "}</span>
                            {currentProduct?.data?.productDetails?.shelf_life_name}
                          </p>
                          <p>
                            <span>{"Generic Name: "}</span>
                            {currentProduct?.data?.productDetails?.product_category}
                          </p>
                          <p>
                            <span>{"Registered City: "}</span>
                            {currentProduct?.data?.sellerAddress?.city}
                          </p>
                          <p>
                            <span>{"Registered District: "}</span>
                            {currentProduct?.data?.sellerAddress?.district}
                          </p>
                          <p>
                            <span>{"Registered State: "}</span>
                            {currentProduct?.data?.sellerAddress?.state}
                          </p>
                        </>
                      )
                    }

                    {!auth.loggedIn && <>{noLoginText}</>}
                  </div>
                </div>
                <Accordion defaultActiveKey={null} className="product-discription-div mobile">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <h4 className="text-uppercase">{"additional information"}</h4>
                    </Accordion.Header>
                    {
                      // Displaying additional information about the product only if the seller type is advanced
                      auth.loggedIn && (
                        <Accordion.Body>
                          <p>
                            <span>{"Manufactured by: "}</span>
                            {currentProduct?.data?.productDetails?.manufactured_by}
                          </p>
                          <p>
                            <span>{"Marketed by: "}</span>
                            {currentProduct?.data?.productDetails?.marketed_by}
                          </p>
                          <p>
                            <span>{"Net Quantity: "}</span>
                            {convertToLiters(currentProduct?.data?.productDetails?.variant)}
                          </p>
                          <p>
                            <span>{"Customer care: "}</span>
                            {currentProduct?.data?.productDetails?.customer_care}
                          </p>
                          <p>
                            <span>{"Country of Origin: "}</span>
                            {currentProduct?.data?.productDetails?.country_of_origin}
                          </p>
                          <p>
                            <span>{"Shelf life: "}</span>
                            {currentProduct?.data?.productDetails?.shelf_life_name}
                          </p>
                          <p>
                            <span>{"Generic Name: "}</span>
                            {currentProduct?.data?.productDetails?.product_category}
                          </p>
                        </Accordion.Body>
                      )
                    }
                    {auth.loggedIn && !isSellerAdvanced && (
                      <Accordion.Body>{enquireText}</Accordion.Body>
                    )}

                    {!auth.loggedIn && <>{noLoginText}</>}
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </Col>

          {otherProducts()}
        </Row>
      </div>
    );
  };

  const otherProducts = () => {
    return (
      <Col xs={12} sm={12} md={3} lg={3}>
        <div className="other-poduct-section">
          <h2 className="text-uppercase">{"Other Products"}</h2>
          {(() => {
            if (currentProduct?.data?.otherProductsDataFinal?.length > 0) {
              return currentProduct?.data?.otherProductsDataFinal.map((product, index) => {
                if (index < 4) {
                  return (
                    <>
                      <hr />
                      <Row className="other-card">
                        <Col
                          sm={2}
                          md={4}
                          lg={3}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            maxHeight: "6rem",
                          }}
                          className="p-0 flex"
                        >
                          <Image
                            onClick={(e) => handleClick(e, product)}
                            style={{ maxHeight: "100%", maxWidth: "100%" }}
                            src={product?.productImages[0]?.url}
                            alt={product?.brand_name}
                          />
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={9} className="p-0">
                          <Link to={`/product/${product.id}`}>
                            <h5>
                              {product?.brand_name}&nbsp;{product?.product_category}&nbsp;
                              {convertToLiters(product.variant)}
                              {" | "}
                              {product.moq}&nbsp;{"Case"}
                            </h5>
                          </Link>
                          <p>
                            {"Pack of"}&nbsp;{product?.packaging_size}&nbsp;{"Bottles"}
                          </p>

                          <div className="brand-card-product">
                            {auth.loggedIn && (
                              <>
                                <h3>
                                  {`₹  ${product.price} `}
                                  <span>{"per case"}</span>
                                </h3>
                              </>
                            )}
                            {!auth.loggedIn && (
                              <>
                                <h3>
                                  <span>{"Please Login to Buy..."}</span>
                                </h3>
                                <CustomButton onClick={openLoginModal}>
                                  <CartIcon />
                                  &nbsp;{"LOGIN"}
                                </CustomButton>
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  );
                } else {
                  // for removing waring  Array.prototype.map() expects a value to be returned at the end of arrow function
                  return <></>;
                }
              });
            } else {
              return <p className="p-3">Products not found </p>;
            }
          })()}
        </div>
      </Col>
    );
  };

  const otherVariants = () => (
    <div className=" section-other-variant container ">
      <hr />
      <div className="text-uppercase section-other-variant-title-div">
        <h4 className="text-uppercase section-title">
          {"Other Variant"}
          <div id="borderLeft" style={{ width: "15%" }}></div>
        </h4>
        {
          <Link
            to={`/brands?brand=${
              currentProduct?.data?.productDetails.brand_name +
              "|" +
              currentProduct?.data?.productDetails.brand_id
            }`}
          >
            {"View More"}
          </Link>
        }
      </div>
      <Row className="m-0">
        {(() => {
          if (currentProduct?.data?.otherVariantsDataFinal?.length > 0) {
            return currentProduct?.data?.otherVariantsDataFinal.map((variant, index) => {
              if (index < 4) {
                return (
                  <Col xs={6} sm={6} md={6} lg={3} className="brand-card-col">
                    <BrandCard isLoggedIn={auth.loggedIn} item={variant} addToCart={addToCart} />
                  </Col>
                );
              } else {
                // for removing waring  Array.prototype.map() expects a value to be returned at the end of arrow function
                return <></>;
              }
            });
          } else {
            return <p>No variant found</p>;
          }
        })()}
      </Row>
    </div>
  );

  return (
    <section className="product-main-section">
      {(() => {
        if (!currentProduct.loading && !isEmpty(currentProduct?.data)) {
          return (
            <>
              {" "}
              {ProductBanner}
              {blandsSections()}
              {otherVariants()}
              {<RefferSection />}
            </>
          );
        } else {
          return (
            <Container style={{ minHeight: "500px", padding: "5rem" }}>
              <Spinner />
            </Container>
          );
        }
      })()}
    </section>
  );
}

export default Product;
